import angular from 'angular';
import $ from 'jquery';

export default class UserRollMessages {
  constructor($scope, UserRollMessageService) {
    $scope.open_dialog = function(dialog_id) {
      window.openFancyboxDialog('div#' + dialog_id);
    };

    $scope.add_message = function() {
      $scope.dialog_message = angular.copy(window.admin_message);
      $scope.open_dialog('user_roll_message_dialog');
    };

    $scope.edit_message = function(message) {
      $scope.dialog_message = message;
      $scope.open_dialog('user_roll_message_dialog');
    };

    $scope.delete_message = function(index) {
      if (confirm('Are you sure you want to delete this message?')) {
        UserRollMessageService.delete($scope.user_roll_messages[index].id).then(function(data) {
          if (data.success)
            $scope.user_roll_messages.splice(index, 1);
        });
      }
    };

    $scope.save_message = function() {
      $scope.updating_message = true;
      UserRollMessageService.save($scope.dialog_message).then(function(data) {
        if (data.success) {
          $scope.updating_message = false;
          $.fancybox.close();
          $scope.user_roll_messages = data.user_roll_messages;
        }
      });
    };

    $scope.init = function() {
      $scope.user_roll_messages = window.user_roll_messages;
      $scope.dialog_message = angular.copy(window.admin_message);
    };

    $scope.init();
  }
}

UserRollMessages.$inject = ['$scope', 'UserRollMessageService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/user-roll-messages.ctrl.js